import React from 'react';
import { ChevronUpDownIcon, ChevronUpIcon, ChevronDownIcon } from '@heroicons/react/24/outline';

/**
 * A clickable column heading.
 *
 * Sorting lives on the server — these tables are paginated, so sorting the
 * twenty rows in the browser would reorder the page rather than the data and
 * quietly lie about what is at the top.
 *
 * Each column names the sort key it sends for each direction. Columns that
 * only sort one way (an audit log reads newest-first or oldest-first and
 * nothing else) pass the same key twice.
 */
export default function SortHeader({ label, asc, desc, sort, onSort, align = 'left' }) {
  const active = sort === asc || sort === desc;
  // Clicking an inactive column starts ascending, except where only a
  // descending key exists. Clicking the active one turns it round.
  const next = sort === asc ? (desc || asc) : (asc || desc);

  const Icon = !active ? ChevronUpDownIcon : (sort === asc ? ChevronUpIcon : ChevronDownIcon);

  return (
    <th
      onClick={() => onSort(next)}
      style={{ cursor: 'pointer', userSelect: 'none', textAlign: align, whiteSpace: 'nowrap' }}
      title={`Sort by ${label.toLowerCase()}`}
      aria-sort={!active ? 'none' : (sort === asc ? 'ascending' : 'descending')}
    >
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
        {label}
        <Icon style={{
          width: 13, height: 13,
          opacity: active ? 0.9 : 0.35,
          flexShrink: 0,
        }} />
      </span>
    </th>
  );
}
